import { useEffect } from 'preact/hooks';

import { SportUpcomingEventTransformed } from '../../hooks/SportUpcomingEventsProvider/types';
import { useTracker } from '../../hooks/useTracker';

import { SportUpcomingEventImage } from './SportUpcomingImage';

export const SportUpcomingEvent = ({
  event,
}: {
  event: SportUpcomingEventTransformed;
}) => {
  const { trackButtonClick, trackView } = useTracker();

  useEffect(() => {
    trackView({
      elementType: 'SportUpcomingEvent',
      name: 'SportUpcomingEvent',
    });
  }, [trackView]);

  return (
    <a
      href={event.url}
      rel="noopener nofollow"
      onClick={() =>
        trackButtonClick('SportUpcomingEvent', {
          '@id': `sdrn:vglive:sportevent:${event.id}`,
          '@type': 'SportEvent',
          'url': event.url,
        })
      }
      className="vgp-sport-upcoming-event"
    >
      <SportUpcomingEventImage image={event.participants[0].image} />
      -
      <SportUpcomingEventImage image={event.participants[1].image} />
    </a>
  );
};
